import { version } from "../version"

export const environment = {
  production: true,
  stage: 'production',
  version,
  title: 'InfluxTv',
  apiEndpoint: 'https://tv.influxhq.com/',
  fayeEndpoint: 'https://tv.influxhq.com/faye'
}
